<template>
  <header
    :class="{
      'bd-banner-navbar': isBannerEnabled,
      'bd-navbar-border-repairify': isRepairifyUkOnly,
      'bd-navbar-border-mahle': isMahle(),
      'bd-navbar-border-default': !isRepairifyUkOnly && !isMahle(),
      'bd-navbar-border-clever': isClever()
    }"
  >
    <div class="row custom-row">
      <!-- Logo -->
      <div class="col-sm">
        <div class="custom-logo">
          <img :src="logo" alt="diagnostics" style="height: 48px" />
        </div>
      </div>

      <!-- App Name -->
      <div class="col-sm custom-title">
        <h2 class="custom-title">{{ t(appName()) || t('app.name.default') }}</h2>
      </div>

      <!-- User Info -->
      <div class="col-sm">
        <div class="custom-user">
          <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
            <!-- Logged-in user (unchanged) -->
            <li v-if="userProfile && userProfile.userName" class="nav-item">
              <a
                id="userProfile"
                href="#"
                :class="{
                  'nav-link': !isClever(),
                  'nav-link-clever': isClever(),
                  'custom-link': true
                }"
                title="userProfile"
                @click.prevent="goUserProfile"
              >
                <font-awesome-icon icon="user" class="pr-1" />
                {{ userProfile.userName }}
              </a>
            </li>

            <!-- Logout -->
            <li class="nav-space nav-item">
              <a
                id="logout"
                href="#"
                :class="{
                  'nav-link': !isClever(),
                  'nav-link-clever': isClever(),
                  'custom-link': true
                }"
                title="logout"
                @click.prevent="logout"
              >
                <font-awesome-icon icon="sign-out-alt" />
                {{ t('logout.label.title') }}
              </a>
            </li>
          </ul>

          <!-- Display name line: BUSINESS USER if selected, else fallback to logged-in profile -->
          <div v-if="displayLastName" class="custom-name">
            <span>{{ displayLastName }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { appId, appName, logoPath, isMahle, isRepairify, isClever } from '@/plugins/globals.js'
import { forceLogout } from '@/helpers/auth'

const store = useStore()
const { t } = useI18n()

// Logged-in user (JWT-derived profile)
const userProfile = computed(() => store.getters['auth/userProfile'] || {})

// Selected business user (chat identity) — hydrated on initState
const chatAs = computed(() => store.getters['auth/chatAs'] || null)

// Name to show under the menu: prefer selected business user; fallback to logged-in profile
const displayLastName = computed(() => {
  const lastFromChat = chatAs.value?.lastName?.trim()
  if (lastFromChat) return lastFromChat
  return (userProfile.value?.lastName || '').trim()
})

// Banner + branding
const isUKOnly = computed(() => parseInt(appId()) === 1)
const isRepairifyUkOnly = computed(() => isUKOnly.value && isRepairify())
const isBannerEnabled = computed(() => {
  const env = window.config ? window.config.environment : ''
  return env !== 'prod'
})
const logo = computed(() => (appId() === 5 ? '/static/protech.svg' : logoPath()))

// Actions
const logout = async () => {
  forceLogout()
  window.location.assign('/')
}
const goUserProfile = async () => {
  if (!isMahle()) {
    window.location.assign('/user/')
  }
}
</script>

<style scoped>
.custom-row { width: 100%; }
.custom-title { text-align: center; width: 100%; margin: 0 auto; }
.custom-link { cursor: pointer; }
.nav-link-clever { padding-right: 0.5rem; padding-left: 0.5rem; color: #000000; }
.nav-link-clever:active { color: #EAAA00; background-color: transparent; }
.nav-link-clever:hover { color: #EAAA00; background-color: transparent; }
.custom-user { float: right; }
.custom-name { text-align: center; font-size: 0.8em; margin: 0 auto; padding: 0; width: 100%; }
.custom-logo { text-align: center; padding-bottom: 20px; }
.nav-space { padding-left: 15px; }
</style>
